/*
  eg-kitchen.js : interactions « premium et ludiques » inspirées des études de dqnamo.com/kitchen (15/10/2026),
  réécrites pour Bottega (aucun code repris). Script autonome, chargé en defer après eg-app.js ; il n'appelle que l'API
  publique du thème (boutons [data-confirm-empty] de eg-app.js). Rien ne bouge avec prefers-reduced-motion.
  - Bouton dynamique : le sélecteur de quantité qui remplace « Ajouter » (0 → 1) s'étire, avec une coche.
  - Ticket de caisse : le récapitulatif du panier s'imprime à l'arrivée sur la page.
  - Maintenir pour vider : appui long (0,9 s) sur « Vider mon panier » = vidage direct, avec l'annulation habituelle ;
    un clic simple ouvre toujours la confirmation (clavier et lecteurs d'écran inchangés).
  - Rails à bords estompés, reflet irisé (carte cadeau), code brouillé puis révélé ([data-eg-scramble]).
*/
(function () {
  'use strict';
  var doc = document;
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var closest = function (t, sel) { return t && t.nodeType === 1 && t.closest ? t.closest(sel) : null; };

  /* Bouton dynamique. paintWrap (eg-app.js) remplace le contenu de [data-qty-for] : un bouton [data-add] retiré et un
     .step ajouté = passage de 0 à 1 article. */
  if (!REDUCE && 'MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var w = m.target;
        if (w.nodeType !== 1 || !w.hasAttribute('data-qty-for')) return;
        var avaitAjout = Array.prototype.some.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.matches('button[data-add]'); });
        var step = w.querySelector('.step');
        if (!avaitAjout || !step) return;
        step.classList.add('eg-pop');
        setTimeout(function () { step.classList.remove('eg-pop'); }, 1300);
      });
    }).observe(doc.body, { childList: true, subtree: true });
  }

  /* Ticket de caisse : seulement au premier affichage (les rafraîchissements du panier remplacent le nœud). */
  var recap = doc.querySelector('.recap');
  if (recap && !REDUCE) recap.classList.add('eg-print');

  /* Maintenir pour vider. */
  var HOLD = 900, timer = null, fait = false;
  var stop = function () {
    if (timer) { clearTimeout(timer); timer = null; }
    Array.prototype.forEach.call(doc.querySelectorAll('.eg-holding'), function (x) { x.classList.remove('eg-holding'); });
  };
  doc.addEventListener('pointerdown', function (e) {
    var b = closest(e.target, '.cart-actions [data-empty]');
    /* 16/10 (audit du code, point 23) : appui long réservé à la souris et au stylet ; au doigt, le bouton ouvre la confirmation. */
    if (!b || e.button > 0 || e.pointerType === 'touch') return;
    fait = false;
    stop();
    b.classList.add('eg-holding');
    timer = setTimeout(function () {
      timer = null;
      fait = true;
      b.classList.remove('eg-holding');
      if (navigator.vibrate) { try { navigator.vibrate(18); } catch (err) {} }
      var c = doc.createElement('button');
      c.type = 'button';
      c.hidden = true;
      c.setAttribute('data-confirm-empty', '');
      doc.body.appendChild(c);
      c.click();
      c.remove();
    }, HOLD);
  });
  ['pointerup', 'pointercancel'].forEach(function (t) { doc.addEventListener(t, stop, true); });
  doc.addEventListener('pointerleave', function (e) { if (closest(e.target, '.cart-actions [data-empty]')) stop(); }, true);
  doc.addEventListener('click', function (e) {
    if (fait && closest(e.target, '[data-empty]')) { e.preventDefault(); e.stopImmediatePropagation(); fait = false; }
  }, true);

  /* Rails à bords estompés. */
  var fondu = function (el) {
    var reste = el.scrollWidth - el.clientWidth - el.scrollLeft;
    el.classList.toggle('eg-fade-l', el.scrollLeft > 4);
    el.classList.toggle('eg-fade-r', reste > 4);
  };
  var rails = function () {
    Array.prototype.forEach.call(doc.querySelectorAll('.rail, .rounds, .chips'), function (el) {
      if (!el.hasAttribute('data-eg-fade')) {
        el.setAttribute('data-eg-fade', '');
        el.addEventListener('scroll', function () { fondu(el); }, { passive: true });
      }
      fondu(el);
    });
  };
  rails();
  window.addEventListener('load', rails);
  window.addEventListener('resize', rails, { passive: true });

  /* Reflet irisé : suit le pointeur ; sinon balaie lentement la carte. */
  if (!REDUCE) {
    Array.prototype.forEach.call(doc.querySelectorAll('.eg-foil'), function (el) {
      el.classList.add('eg-foil-idle');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.classList.remove('eg-foil-idle');
        el.style.setProperty('--fx', Math.round(((e.clientX - r.left) / r.width) * 100) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.removeProperty('--fx'); el.classList.add('eg-foil-idle'); });
    });
  }

  /* Code brouillé puis révélé, de gauche à droite (le texte final ne change pas). */
  if (!REDUCE) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-eg-scramble]'), function (el) {
      var fin = el.textContent, jeu = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', t0 = null, D = 1000;
      var tour = function (now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / D), n = Math.floor(p * fin.length);
        el.textContent = p >= 1 ? fin : fin.slice(0, n) + fin.slice(n).replace(/[A-Za-z0-9]/g, function () { return jeu.charAt((Math.random() * jeu.length) | 0); });
        if (p < 1) requestAnimationFrame(tour);
      };
      requestAnimationFrame(tour);
    });
  }
})();
